import { apiClient } from "helpers/api_helper";

export const getAllGoldInwardData = async (param: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/ProductDetails/GetSNMCCAndNonSNMCCProductHeaders`, param);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};